import store from '@/public/store';
const DictionaryAPI = {
    /**
     * 获取省份
     * @returns 
     */
    loadProvinces() {
        return Request.get('/admin/area/provinces');
    },

    /**
     * 获取城市
     * @param {*} provinceCode 
     * @returns 
     */
    loadCities(provinceCode) {
        return Request.get('/admin/area/cities', {
            parentCode: provinceCode
        });
    },

    /**
     * 获取地区
     * @param {} cityCode 
     * @returns 
     */
    loadRegions(cityCode) {
        return Request.get('/admin/area/regions', {
            parentCode: cityCode
        });
    },

    /**
     * 获取字典分类列表
     * @param {*} vm 
     * @param {*} pageNo 
     * @returns 
     */
    loadCodeCategory(data) {
        return Request.post("/admin/codeType/search", data);
    },

    /**
     * 保存分类
     * @param {} data 
     * @returns 
     */
    saveCategory(data) {
        return Request.post(`/admin/codeType/save`, data);
    },
    /**
     * 删除字典分类
     * @param {} id 
     * @returns 
     */
    removeCategory(id) {
        return Request.delete(`/admin/codeType/delete/${id}`);
    },

    /**
     * 批量删除字典分类
     * @param {} idArray 
     * @returns 
     */
    batchRemoveCategory(idArray) {
        return Request.post(`/admin/codeType/batchDelete`, idArray);
    },

    /**
     * 获取代码
     */
    loadCodes(categoryId, data) {
        return Request.post(`/admin/code/${categoryId}/list`, data || {});
    },
    batchLoadCodes(categoryCodeArray) {
        return Request.post("/admin/code/batchFindByCategory", categoryCodeArray);
    },
    saveCode(data) {
        return Request.post(`/admin/code/save`, data);
    },
    removeCode(id) {
        return Request.delete(`/admin/code/delete/${id}`);
    },
    onClickBatchRemoveCodes(idArray) {
        return Request.post(`/admin/code/batchDelete`, idArray);
    },
    loadClassCodeTypeList(data) {
        return Request.post("/admin/classCodeType/search", data);
    },
    saveClassCodeType(data) {
        return Request.post(`/admin/classCodeType/save`, data);
    },
    removeClassCodeType(id) {
        return Request.delete(`/admin/classCodeType/delete/${id}`);
    },
    batchRemoveClassCodeType(idArray) {
        return Request.post(`/admin/classCodeType/batchDelete`, idArray);
    },
    findClassCodeList(query) {
        return Request.post(`/admin/classCode/search`, query);
    },
    transalte(items, fieldArray, codeTypeArray) {
        if (Object.prototype.toString.call(items) === '[object Array]') {
            // 数组
            items.forEach(item => {
                for (let i = 0; i < fieldArray.length; i++) {
                    if (item[fieldArray[i]]) {
                        item[fieldArray[i] + "Name"] = this.getCodeName(store.getters.codes[codeTypeArray[i]], item[fieldArray[i]]);
                    }
                }
            });
        }
    },
    getCodeName(codeList, val) {
        let subCodes = codeList.filter(item => item.value == val);
        if (subCodes && subCodes.length > 0) {
            return subCodes[0].name;
        }
        return '';
    },
    codeTree() {
        return Request.get(`/admin/code/codetree`);
    },
    /**
     * 根据父代码的code查询子代码
     * @param {*} parentCode 
     * @returns 
     */
    findSubCategoriesByParentCode(parentCode) {
        return Request.get(`/admin/classCode/findCategoriesByParentCode/${parentCode}`);
    },
    loadClassCodeTree(typeCode) {
        return Request.get(`/admin/classCode/tree/${typeCode}`);
    },
    saveClassCode(data) {
        return Request.post(`/admin/classCode/save`, data);
    },
    removeClassCode(id) {
        return Request.delete(`/admin/classCode/delete/${id}`);
    },
    updateClassCodeSorts(data) {
        return Request.post("/admin/classCode/updateSorts", data);
    }
}
export default DictionaryAPI;